<template>
    <div id="app">
        <!--<div class="header">
            <div class="headerInner">
                <h2></h2>
            </div>
        </div>-->
        <!-- <img src="img/logo.png" width="400px" /> -->
        <h2>City-Wide Yard Sale Submission</h2>

        <div v-if="!submitted">
            <p>Wanting to have a yard sale, but don’t want to deal with all the logistics? We’ve got you covered! Join us for our the City-Wide Yard Sale! We take care of all the advertising, signage and will have location maps for attendees. The best part…it’s completely FREE to register your sale!!</p>
            <p>This year's Yard Sale will take place over two weekends: May 23 & 24 for locations west of 18th Street and May 30 & 31 for locations east of 18th Street.</p>
            <p style="font-weight: 600">West of 18th Street</p>
            <p>Friday, May 23<br/>5:00 – 8:00 p.m.</p>
            <p>Saturday, May 24<br/>9:00 a.m. – 3:00 p.m.</p>
            <p style="font-weight: 600">East of 18th Street</p>
            <p>Friday, May 30<br/>5:00 – 8:00 p.m.</p>
            <p>Saturday, May 31<br/>9:00 a.m. – 3:00 p.m.</p>
            <!-- <p>Location:  Your front yard!</p> -->
            <p><span style="font-weight:600">Registration Deadline:</span> April 21, 2025</p>
            <p>
                To register please complete the form below or call <b>204.729.2471</b><br/>
                Please note that new build and trailer court addresses will not populate. Please email recreation@brandon.ca to register these addresses.
            </p>
            <FormInput @data-submitted="dataSubmitted"></FormInput>
        </div>
        <div class="onSubmit" v-else>
            <p>
                Your information was successfully submitted.
            </p>
            <p>
                You will receive an email confirmation of this submission.
            </p>
            <p>
                <input type="button" value="Back to form" @click="returnToForm" />
            </p>
        </div>

        <MessageBanner :message="banner.message" :error="banner.error" :display-time="banner.displayTime" @banner-hidden="banner.message=''" />
    </div>
</template>

<script>
    import FormInput from './components/FormInput.vue';
    import MessageBanner from './components/MessageBanner.vue';
    import { store } from './store';
    import axios from 'axios';
    import { load } from 'recaptcha-v3';

    export default {
        name: 'app',
        store,
        components: {
            FormInput,
            MessageBanner
        },
        data() {
            return {
                reCaptcha: null,
                configFile: "config.json",
                submitted: false,
                banner: {
                    message: "Banner Test",
                    error: false,
                    displayTime: 0
                }
            }
        },
        computed: {
            captcha: function () {
                return this.$store.state.captcha;
            }
        },
        methods: {
            updateConfig: async function () {
                let { data } = await axios.get(this.configFile);
                this.$store.commit("setConfig", data);
            },
            dataSubmitted: function (data) {
                if (data.error) {
                    this.banner.error = true;
                    if (data.message)
                        this.banner.message = data.message;
                    else
                        this.banner.message = "Error submitting form";
                } // if
                else {
                    this.banner.error = false;
                    this.banner.displayTime = 10000;
                    this.banner.message = "Form successfully submitted!";
                    this.submitted = true;
                } // else
            },
            returnToForm: function () {
                this.$store.commit("clearCurrItem");
                this.submitted = false;
            }
        },
        async mounted() {
            this.$store.commit("clearCurrItem");
            if (this.configFile) {
                await this.updateConfig();
                this.$store.commit("configLoaded");
            } // if

            // Load reCaptcha-v3 and get token
            this.reCaptcha = await load(this.captcha.publicKey);
            let captchaToken = await this.reCaptcha.execute("CitizenCameras");
            this.$store.commit('setCaptchaToken', captchaToken);
        }
    };
</script>

<style>
    /*.header {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 80px;
        background-color: darkslateblue;
    }*/
    /*.headerInner {
        height: 100%;
        width: 100%;
        position: relative;
    }*/
    h3 {
        margin-top: 12px;
        margin-bottom: 8px;
    }
    .headerInner h2 {
        align-self: center;
        font-weight: 600;
        font-size: 32px;
        color: white;
        margin-left: 12px;
    }
    .onSubmit {
        padding-top: 16px;
        /*position: absolute;
        top: 81px;
        left: 12px;
        font-size: 24px;
        font-weight: 600;*/
    }
</style>

